//Componentes generales
import React, { useState, useEffect } from "react";
import AutocompleteV2 from "../AutoCompleteV2/AutoCompleteV2";
import SelectList from "../SelectList/SelectList";

// Estilos
import "./NewProductItm.css";

// Iconos
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBackspace } from "@fortawesome/free-solid-svg-icons";

/*
    Componente encargado de toda la logica del ingreso de un nuevo item en carga de requerimiento.
        Donde data es el item en el cual esta posicionado.
              index es la posición del item.
              productList es la lista de productos disponibles.
              agregaItem es la función que agrega el nuevo item.
              modificaItm es la función que modifica el item.
              borraItem es la función que borra el item.
*/
function NewProductItm({
  data,
  index,
  edicion,
  productsList,
  agregaItem,
  modificaItm,
  borraItem,
  tiposCosto,
  centrosCosto,
}) {
  //state de item.
  const [selected, setSelected] = useState(data);
  const [quantityInput, setQuantityInput] = useState(data.quantity === 0 ? 1 : data.quantity);
  const [priceInput, setPriceInput] = useState(data.price ?? "");

  /* 
        Manejador encargado de la logica del autocompletado ante una modificación.
            Donde value es el valor ingresado por el usuario.
    */
  const handlerChangeAutoComplete = (value) => {
    const indice = index;
    const productoSeleccionado = productsList.find(
      (p) =>
        `${p.tipPro}${p.artCod}`.replace(/\s+/g, "") ===
        value.split(" ~ ")[0].replace(/\s+/g, "")
    );

    if (productoSeleccionado !== undefined) {
      const s = {
        ...data,
        tipPro: productoSeleccionado.tipPro,
        artCod: productoSeleccionado.artCod,
        codRed: productoSeleccionado.codRed,
        descrp: productoSeleccionado.descrp,
        price: productoSeleccionado.price,
        uniMed: productoSeleccionado.uniMed,
      };

      if (data.artCod !== "") modificaItm(s, indice);
      else agregaItem(s);
      setSelected(s);
    }
    if (productoSeleccionado == undefined && value == "") {
      borraItem(data, indice);
      setSelected(data);
    }
  };

  /* 
        Manejador encargado de la modificación de la cantidad del item.
            Donde cantid es el valor ingresado por el usuario.
    */
  const handleChangeQuantity = (cantid) => {
    setQuantityInput(cantid);
  };

  const handleFocusQuantity = () => {
    if (String(quantityInput) === "1") {
      setQuantityInput("");
    }
  };

  const handleBlurQuantity = () => {
    const parsed = parseFloat(quantityInput);
    if (!quantityInput || isNaN(parsed) || parsed <= 0) {
      setQuantityInput(1);
      const s = { ...selected, quantity: 1 };
      setSelected(s);
      modificaItm(s, index);
    } else {
      const s = { ...selected, quantity: parsed };
      setSelected(s);
      modificaItm(s, index);
    }
  };

  /* 
        Manejador encargado de la modificación del texto del item.
            Donde texto es el valor ingresado por el usuario.
    */
  const handleChangeTextAdic = (texto) => {
    const indice = index;
    const s = { ...selected, textAdic: texto };
    setSelected(s);
    modificaItm(s, indice);
  };

  const handleChangePrice = (value) => {
    setPriceInput(value);
  };

  const handleBlurPrice = () => {
    const parsed = parseFloat(priceInput);
    const newPrice = isNaN(parsed) || parsed < 0 ? 0 : parsed;
    setPriceInput(newPrice);
    const s = { ...selected, price: newPrice };
    setSelected(s);
    modificaItm(s, index);
  };

  const handleChangeTipoCosto = async (value) => {
    const tipoCostoSeleccionado = tiposCosto.find(
      (tC) =>
        `${tC.subCue}`.replace(/\s+/g, "") === value.value.replace(/\s+/g, "")
    );

    if (tipoCostoSeleccionado !== undefined) {
      const indice = index;
      const s = {
        ...selected,
        tipoCosto: {
          abmCodDim: tipoCostoSeleccionado.codDim,
          abmCodDimDescrp: tipoCostoSeleccionado.codDimDescrp,
          abmSubCue: tipoCostoSeleccionado.subCue,
          abmSubCueDescrp: tipoCostoSeleccionado.subCueDescrp,
        },
      };
      setSelected(s);
      modificaItm(s, indice);
    }
  };

  const handleChangeCentroCosto = async (value) => {
    const centroCostoSeleccionado = centrosCosto.find(
      (cC) =>
        `${cC.subCue}`.replace(/\s+/g, "") === value.value.replace(/\s+/g, "")
    );

    if (centroCostoSeleccionado !== undefined) {
      const indice = index;
      const s = {
        ...selected,
        centroCosto: {
          abmCodDim: centroCostoSeleccionado.codDim,
          abmCodDimDescrp: centroCostoSeleccionado.codDimDescrp,
          abmSubCue: centroCostoSeleccionado.subCue,
          abmSubCueDescrp: centroCostoSeleccionado.subCueDescrp,
        },
      };
      setSelected(s);
      modificaItm(s, indice);
    }
  };

  return (
    <div style={{
      display: "flex",
      flexDirection: "column",
      width: "100%",
      padding: "10px 14px",
      gap: "6px",
      backgroundColor: "#fff",
      borderRadius: "8px",
      boxShadow: "0 2px 8px rgba(0,0,0,0.10)",
      border: "1px solid #e8e8e8",
      marginBottom: "8px",
    }}>

      {/* Fila 1: ícono + producto + cantidad + descripción adicional */}
      <div className="container-row-form-item" style={{ margin: 0, padding: 0 }}>
        <div>
          <FontAwesomeIcon
            icon={faBackspace}
            color="red"
            style={{
              width: "35px",
              height: "35px",
              cursor: "pointer",
            }}
            onClick={borraItem}
          />
        </div>

        <div className="input-autocomplete-form-item" style={{ flex: 2 }}>
          <AutocompleteV2
            placeholder={"Ingrese un producto"}
            height={"40px"}
            value={
              selected.tipPro !== ""
                ? `${selected.tipPro}${selected.artCod} ~ ${selected.descrp}`
                : ""
            }
            setValue={handlerChangeAutoComplete}
            dataSuggestions={productsList.map((p) => {
              return {
                code: `${p.tipPro}${p.artCod}`,
                descrp: `${p.descrp} (${p.codRed})`,
              };
            })}
          />
        </div>

        <div style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "6px", marginRight: "10px" }}>
          <input
            value={quantityInput}
            type="number"
            placeholder="Cant."
            onChange={(datat) => handleChangeQuantity(datat.target.value)}
            onFocus={handleFocusQuantity}
            onBlur={handleBlurQuantity}
            style={{
              height: "40px",
              width: `${Math.max(4, String(quantityInput).length) * 14 + 16}px`,
              textAlign: "center",
              fontSize: "1rem",
              borderRadius: 5,
              border: "none",
              boxShadow: "rgba(148, 142, 142, 0.59) 4px 5px 5px 0px",
              textShadow: "0.5px 0.5px 0.5px rgba(0,0,0,0.4)",
            }}
          />
          {selected.uniMed && (
            <span style={{ fontSize: "0.95rem", fontWeight: "700", color: "#4a4a4a", whiteSpace: "nowrap" }}>
              {selected.uniMed}
            </span>
          )}
        </div>

        <input
          value={selected.textAdic}
          placeholder="Descripción adicional"
          onChange={(datat) => handleChangeTextAdic(datat.target.value)}
          style={{
            flex: 1,
            fontSize: "1rem",
            height: "40px",
            borderRadius: 5,
            border: "none",
            boxShadow: "rgba(148, 142, 142, 0.59) 4px 5px 5px 0px",
            textShadow: "0.5px 0.5px 0.5px rgba(0,0,0,0.4)",
          }}
        />
      </div>

      {/* Fila 2: precio (edicion) + tipo de costo + centro de costo */}
      {(edicion === "Edicion" && selected.artCod !== "" || tiposCosto || centrosCosto) && (
        <div style={{
          display: "flex",
          flexDirection: "row",
          gap: "8px",
          paddingTop: "6px",
          borderTop: "1px solid #ebebeb",
          justifyContent: "center",
          alignItems: "center",
        }}>
          {edicion === "Edicion" && selected.artCod !== "" && (
            <div style={{ display: "flex", flexDirection: "column" }}>
              <div style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "6px" }}>
                <span style={{ fontSize: "1.2rem", fontWeight: 600, color: "#4a4a4a", textShadow: "0.5px 0.5px 0.5px rgb(0, 0, 0)" }}>USD</span>
                <input
                  type="number"
                  value={priceInput}
                  onChange={(e) => handleChangePrice(e.target.value)}
                  onBlur={handleBlurPrice}
                  className="price-input"
                  style={{
                    height: "40px",
                    width: "150px",
                    fontWeight: "600",
                    fontSize: "1.2rem",
                    textAlign: "left",
                    fontSize: "1.1rem",
                    borderRadius: 5,
                    border: "1px solid #ccc",
                    boxShadow: "rgba(148, 142, 142, 0.59) 4px 5px 5px 0px",
                    padding: "0 8px",
                    boxSizing: "border-box",
                  }}
                />
              </div>
            </div>
          )}
          {tiposCosto && (
            <div className="selectSubcuenta" style={{ width: "clamp(200px, 30%, 420px)" }}>
              <SelectList
                colorInputText={selected.tipoCosto?.abmSubCue ? "black" : "#7c7b7b"}
                textShadow={"0.5px 0.5px 0.5px rgba(0,0,0,0.4)"}
                backgroundColor={"white"}
                menuPlacement={"bottom"}
                height={"40px"}
                border={true}
                options={tiposCosto.map((cC) => {
                  return {
                    value: `${cC.subCue}`,
                    label: `${cC.subCue} - ${cC.subCueDescrp}`,
                  };
                })}
                handleChange={handleChangeTipoCosto}
                property={"Tipo de Costo"}
                valueAux={{
                  label: selected.tipoCosto?.abmSubCue
                    ? `${selected.tipoCosto?.abmSubCue} - ${selected.tipoCosto?.abmSubCueDescrp}`
                    : "Seleccione tipo de costo...",
                  value: selected.tipoCosto?.abmSubCue || "",
                }}
                emptyInputs={[]}
                styles={{
                  additionalStyleDivSelectList: { alignItems: "left" },
                  fontStyleTitle: { fontSize: "1rem", color: "#7c7b7b", marginLeft: "9px" },
                }}
                fontWeight="700"
                fontWeightSingleValue="500"
              />
            </div>
          )}
          {centrosCosto && (
            <div className="selectSubcuenta" style={{ width: "clamp(200px, 30%, 420px)" }}>
              <SelectList
                colorInputText={selected.centroCosto?.abmSubCue ? "black" : "#7c7b7b"}
                textShadow={"0.5px 0.5px 0.5px rgba(0,0,0,0.4)"}
                backgroundColor={"white"}
                menuPlacement={"bottom"}
                height={"40px"}
                border={true}
                options={centrosCosto.map((cC) => {
                  return {
                    value: `${cC.subCue}`,
                    label: `${cC.subCue} - ${cC.subCueDescrp}`,
                  };
                })}
                handleChange={handleChangeCentroCosto}
                property={"Centro de Costo"}
                valueAux={{
                  label: selected.centroCosto?.abmSubCue
                    ? `${selected.centroCosto?.abmSubCue} - ${selected.centroCosto?.abmSubCueDescrp}`
                    : "Seleccione centro de costo...",
                  value: selected.centroCosto?.abmSubCue || "",
                }}
                emptyInputs={[]}
                styles={{
                  additionalStyleDivSelectList: { alignItems: "left" },
                  fontStyleTitle: { fontSize: "1rem", color: "#7c7b7b", marginLeft: "9px" },
                }}
                fontWeight="700"
                fontWeightSingleValue="500"
              />
            </div>
          )}
        </div>
      )}

    </div>
  );
}

export default NewProductItm;